<template>
  <OrFabV3
    icon="add"
    :tooltip="$t('common.create')"
    color="primary"
    @click="$emit('click')"
  />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { OrFabV3 } from '@onereach/ui-components';

export default defineComponent({
  name: 'QueuesAddButton',
  components: {
    OrFabV3,
  },
  emits: ['click'],
});
</script>
